export default __webpack_public_path__ + "static/media/Imagine.da47305b.svg";